import React from 'react';
import { Button, SpaceBetween, Spinner } from '@amzn/awsui-components-react';
import { LockInfo } from 'src/models/common/LockInfo';
import { isLockedByOther } from './editLockUtils';
import { DEFAULT_LOCK_MESSAGES, Action } from './constants';
import CONSTANTS from 'src/utils/constants';

export interface EditLockButtonBarProps {
    viewMode?: string;
    lockInfo?: LockInfo | null;
    lockInfoLoading: boolean;
    metadataLoaded?: boolean;
    currentUser?: string;
    actionInProgress: Action | null;
    onEdit: () => void;
    onSave: () => void;
    onConfirm: () => void;
    onRevert: () => void;
}

export function EditLockButtonBar(props: EditLockButtonBarProps) {
    const { viewMode, lockInfo, lockInfoLoading, metadataLoaded = true, currentUser, actionInProgress, onEdit, onSave, onConfirm, onRevert } = props;
    const anyActionInProgress = actionInProgress !== null;
    const lockedByOther = isLockedByOther(lockInfo, currentUser);
    const isLoading = lockInfoLoading || !metadataLoaded;

    if (!metadataLoaded) {
        return null;
    }

    if (isLoading && !anyActionInProgress) {
        return <Spinner size="normal" />;
    }

    if (actionInProgress === Action.EDIT) {
        return (
            <Button variant="primary" loading={true} disabled={true}>
                Edit
            </Button>
        );
    }

    if (actionInProgress === Action.CONFIRM || actionInProgress === Action.REVERT || actionInProgress === Action.SAVE) {
        return (
            <SpaceBetween direction="horizontal" size="s">
                <Button variant="normal" loading={actionInProgress === Action.SAVE} disabled={true}>
                    Save
                </Button>
                <Button variant="normal" loading={actionInProgress === Action.REVERT} disabled={true}>
                    Revert
                </Button>
                <Button variant="primary" loading={actionInProgress === Action.CONFIRM} disabled={true}>
                    Confirm
                </Button>
            </SpaceBetween>
        );
    }

    if (viewMode === CONSTANTS.VIEW_MODE.EDITABLE && !lockedByOther) {
        return (
            <SpaceBetween direction="horizontal" size="s">
                <Button variant="normal" onClick={onSave}>Save</Button>
                <Button variant="normal" onClick={onRevert}>Revert</Button>
                <Button variant="primary" onClick={onConfirm}>Confirm</Button>
            </SpaceBetween>
        );
    }

    return (
        <Button
            variant="primary"
            disabled={lockedByOther}
            disabledReason={
                lockedByOther
                    ? DEFAULT_LOCK_MESSAGES.lockedByOther(lockInfo?.lockedBy || 'another user')
                    : undefined
            }
            onClick={onEdit}
        >
            Edit
        </Button>
    );
}

export default EditLockButtonBar;
